export const interactionToolsConfig = {
  /**
   * Chat messaging limits.
   */
  CHAT: {
    /**
     * Configuration of 'whether show confirmation modal' parameter.
     */
    ASK_TO_DELETE_CHAT_MESSAGE: true,
    /**
     * No more than 2 messages per second from one front-end client.
     */
    MESSAGE_SENDING_THROTTLE: 500,
    /**
     * Buffer of in-memory reserved messages.
     * In case if something is deleted, we want to know what happened before.
     */
    IN_MEMORY_MESSAGES_BUFFER: 50,
    /**
     * Display only 100 last messages in widget and work with limited history.
     */
    IN_MEMORY_MESSAGES_LIMIT: 100,
    /**
     * Max length of message input in chat.
     * In DB it is not limited, but some clients can send them from mobile/studio etc.
     */
    MAX_MESSAGE_LENGTH: 512,
    /**
     * Time to batch messages before rendering everything.
     * Messages should not render as they appear because it will ruin performance in case of 1000s of active users.
     */
    MESSAGE_UPDATE_THROTTLE: 300,
  },
  /**
   * QNA tools limits.
   */
  QNA: {
    /**
     * Max length of question input in qna.
     * In DB it is not limited, but some clients can send them from mobile/studio etc.
     */
    MAX_QUESTION_LENGTH: 240,
    /**
     * Max length of question reply input in qna.
     * In DB it is not limited, but some clients can send them from mobile/studio etc.
     */
    MAX_QUESTION_REPLY_LENGTH: 240,
    /**
     * A time period of the updates of the question asked time.
     */
    QNA_POSTED_AT_REFRESH_PERIOD: 1500,
    /**
     * Time to wait before send another question.
     */
    QUESTION_ASKING_THROTTLE: 1_500,
    /**
     * Time to wait before send another reply in the form.
     */
    QUESTION_REPLY_THROTTLE: 5_000,
    /**
     * Time to batch qna replies before rendering everything.
     * Replies should not render as they appear because it will ruin performance in case of 1000s of active users.
     */
    QNA_REPLIES_UPDATE_THROTTLE: 300,
    /**
     * Time threshold (in ms) to consider a question as "just now" (e.g., to display a special indicator or badge).
     * 60 seconds.
     */
    JUST_NOW_THRESHOLD: 60_000,
  },
  /**
   * Poll tools limits.
   */
  POLLS: {
    MAX_QUESTION_LENGTH: 120,
    MAX_OPTION_LENGTH: 120,
    MAX_OPTION_COUNT: 4,
  },
  EXPORT_DOWNLOAD_THROTTLE_DELAY: 2000,
  /**
   * Int-x tools related regular expressions.
   */
  REGEXP: {
    /**
     * Used to detect links in user chat messages.
     */
    DEFAULT_LINK:
      /(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)*(?:(?:\d(?!\.)|[a-z\u00A1-\uFFFF])(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)+[a-z\u00A1-\uFFFF]{2,}(?::\d{2,5})?(?:[#/?]\S*)?/gi,
    LINK_PROTOCOL: /((https?|ftp):\/\/)/,
  },
  /**
   * Interaction tools auth limits.
   */
  AUTHORIZATION: {
    MIN_DISPLAYNAME_LENGTH: 1,
    MAX_DISPLAYNAME_LENGTH: 40,
    ROOM_GUEST_CODE_LENGTH: 36,
    /**
     * @deprecated - remove after leads release
     */
    REGISTRANT_COOKIE: (webinarUuid: string) => `${webinarUuid}_webinar_registrant`,
  },
  INTERACTION_ROOM_STATUS_POLLING_INTERVAL: 4000,
  BROADCAST_CHANNEL: {
    NAME: 'embed-communications',
    MESSAGE_TYPE: {
      ASK_DATA: 'ask_data',
      NEW_DATA: 'new_data',
    },
  },
};
